module.exports = __webpack_public_path__ + "img/98.9d5543e4.jpg";